import type React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import type { CalendarEvent } from "@/types/calendarEvent";
import {
	getLocationImage,
	fetchNextEvent,
	getLocationName,
	formatTimeRange,
} from "@/utils/googleCalendar";

const Schedule: React.FC = () => {
	const [event, setEvent] = useState<CalendarEvent | null>(null);

	useEffect(() => {
		fetchNextEvent().then((fetchedEvent) => {
			setEvent(fetchedEvent);
		});
	}, []);

	return (
		<section className="py-16 bg-gray-100">
			<div className="container mx-auto">
				<h2 className="text-3xl font-bold text-center mb-12">
					次回のもくもく会
				</h2>
				<div className="max-w-2xl mx-auto">
					{event ? (
						<div className="bg-white rounded-lg shadow-md overflow-hidden">
							<img
								src={getLocationImage(event.location || "")}
								alt={event.summary}
								className="w-full h-48 object-cover"
							/>
							<div className="p-6">
								<h3 className="text-xl font-semibold mb-4">{event.summary}</h3>
								<p className="mb-2">
									開催日: {new Date(event.start.dateTime).toLocaleDateString()}
								</p>
								<p className="mb-2">
									時間:{" "}
									{formatTimeRange(event.start.dateTime, event.end.dateTime)}
								</p>
								<p>
									場所:{" "}
									{event.location ? (
										<Link
											to={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
												event.location,
											)}`}
											target="_blank"
											rel="noopener noreferrer"
											className="text-blue-500 hover:underline"
											title="マップを表示します"
										>
											{getLocationName(event.location)}
										</Link>
									) : (
										"未定"
									)}
								</p>
							</div>
						</div>
					) : (
						<p className="text-center text-gray-600">
							次のイベントはありません。
						</p>
					)}
				</div>
			</div>
		</section>
	);
};

export default Schedule;
